export const disallowedKeywords = [
  ".this",
  //"()",
  "function",
  "=>",
  "return",
  "var",
  "let",
  "const",
  "new",
  "delete",
  "this",
  "window",
  "document",
  "alert",
  "confirm",
  "prompt",
  //"console",
  "debugger",
  "import",
  "export",
  "require",
  "module",
  "global",
  "process",
  "Buffer",
  "setInterval",
  "setTimeout",
  "Promise",
  "async",
  "await",
  "fetch",
  "XMLHttpRequest",
  "eval",
  "Function",
];
